define('product_details_quantity.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('product_details_quantity', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return " <div> "
    + ((stack1 = _nl_(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? _nl_(depth0,"showQuantity") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(7, data, 0),"data":data,"loc":{"start":{"line":1,"column":7},"end":{"line":1,"column":581}}})) != null ? stack1 : "")
    + " </div>  ";
},"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return " <div class=\"product-details-quantity-options\" data-validation=\"control-group\"><div class=\"qty\"><span>Qty</span><select data-action=\"changeQuantity\" name=\"quantity\" id=\"quantity\" style=\"background-image:url('/SSP Applications/AAMedicalStore/AAMedicalStore/img/Dropdown Arrow.svg')\"> "
    + ((stack1 = _nl_(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? _nl_(depth0,"itemAvailableQuantityArray") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(5, data, 0),"data":data,"loc":{"start":{"line":1,"column":310},"end":{"line":1,"column":480}}})) != null ? stack1 : "")
    + " </select></div></div> ";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1;

  return " "
    + ((stack1 = _nl_(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? _nl_(depth0,"itemAvailableQuantityArray") : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":345},"end":{"line":1,"column":434}}})) != null ? stack1 : "")
    + " ";
},"3":function(container,depth0,helpers,partials,data) {
    return " <option value=\""
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "\">"
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "</option> ";
},"5":function(container,depth0,helpers,partials,data) {
    return " <option value=\"1\">1</option> ";
},"7":function(container,depth0,helpers,partials,data) {
    return " <input type=\"hidden\" name=\"quantity\" id=\"quantity\" value=\"1\"> ";
},"useData":true}, 'extensions/C3/SCAB2C2023/1.0.7/', 'extensions/C3/SCAB2C2023/1.0.7/', Handlebars);
});